import React from 'react';
import OpeningHoursTable from 'gatsby-theme-pages/src/components/opening-hours-table';
import { transformOpeningHours } from 'gatsby-theme-core/src/hooks/use-opening-hours';
import Column from '../../column';

const OpeningHours = ({
  className,
  columnWidth,
  align,
  justify,
  order,
  card,
  offset,
  openingHours,
}) => {
  const data = transformOpeningHours(openingHours);
  return (
    <Column
      className={className}
      columnWidth={columnWidth}
      align={align}
      justify={justify}
      order={order}
      offset={offset}
      card={card}
    >
      <OpeningHoursTable
        openingHours={data}
      />
    </Column>
  );
};
export default OpeningHours;
